export default {
    "accountValidateMsg" : "Account must contain 6 - 30 characters, including letters, digits and symbols (\".\", \"_\", \"@\"). The first character must be digit or letter.",
    "storeSuccess" : "Пополнение прошло успешно",
    "editAccountTips" : "Please enter a valid account name",
    "editPwdTips" : "Please enter a valid password",
    "editRepeatPwdTips" : "Please enter your password again",
    "pwdRepeatTips" : "Passwords do not match",
    "changePwdSucc" : "Your password has been changed",
    "bindEmail" : "Привязать эл. почту",
    "errorVrifyCodeTips" : "verification code error",
    "slectQuessionTips" : "Please select a security question?",
    "answerTips" : "Please enter the answer",
    "twoAnswerTips" : "Please select created security questions and enter the correct answers",
    "realNameValidateTips" : "Real name (4 to 60 characters)",
    "phoneValidateTips" : "Phone Number(6 to 18 digits)",
    "areaSelectTips" : "Please select region",
    "iDCardValidataTips" : "ID Number(1 to 60 digits)",
    "changeProfileSucc" : "Updated info saved",
    "editVrfCodeTips" : "Please enter verify code",
    "securityQuestionTips" : "Выберите секретные вопросы, чтобы обезопасить ваш аккаунт. С их помощью вы сможете сбросить пароль, если его забудете.",
    "validateQuessionTips" : "Выберите два разных вопроса и выполните проверку. Вопросы можно поменять после проверки.",
    "originPwd" : "Текущий пароль",
    "newPwd" : "Новый пароль",
    "changePwdSuccess" : "Пароль изменен. Рекомендуем войти в аккаунт прямо сейчас, чтобы сохранить прогресс.",
    "accountName" : "Название аккаунта",
    "password" : "Пожалуйста, введите свой пароль",
    "repeatPassword" : "Подтвердите пароль",
    "findPwdTips" : "Укажите аккаунт, для которого хотите восстановить пароль",
    "submit" : "отправить",
    "send" : "Отправить",
    "modify" : "Изменить",
    "haveAgree" : "Я согласен с [Политикой конфиденциальности] и [Положениями и условиями]",
    "and" : "и",
    "privacyPolicy" : "Политика конфиденциальности",
    "completeness" : "Завершение:",
    "gender" : "Пол",
    "male" : "Мужчина",
    "female" : "Женщина",
    "birthday" : "Дата рождения",
    "phone" : "Номер телефона",
    "region" : "Страна/регион",
    "ID" : "-",
    "accountSetting" : "Настройки аккаунта",
    "upgrade" : "Улучшить",
    "profile" : "Профиль",
    "changePassword" : "Смена пароля",
    "securityQuestion" : "Секретные вопросы",
    "creatework_headerTitle" : "Create Ticket",
    "mylist_headerTitle" : "My Ticket",
    "bindEmailTips" : "Пройдите проверку эл. почты для повышения уровня безопасности аккаунта. На этот адрес эл. почты мы вышлем пароль, если вы его забудете.",
    "enterEmailVrfcationTips" : "Введите код подтверждения.",
    "cancel" : "ОТМЕНА",
    "bindTps" : "Bind your account to play the game on multiple devices!",
    "login" : "Войти",
    "logout" : "выйти",
    "bind" : "Привязка аккаунта",
    "feedback" : "Написать нам",
    "terms" : "Положения и условия",
    "tips" : "Примечание",
    "debindTips" : "После отвязки аккаунта повышается риск потери данных. Хотите отвязать аккаунт?",
    "debindText" : "Отвязать",
    "guestSwitchTips" : "Обнаружен гостевой аккаунт. После входа данные гостевого аккаунта будут удалены, продолжить?",
    "register" : "зарегистрироваться",
    "realName" : "-",
    "enterEmailTips" : "Укажите адрес эл. почты",
    "emailVAlidateMsg" : "invalid email",
    "editEmaileTips" : "Please enter your email address",
    "checkServiceTips" : "Please read Terms of Use and Privacy Policy first.",
    "brithdayValidateTips" : "Enter your birthday",
    "facebookValidateTips" : "Facebook Account (1 to 60 characters)",
    "eritOriginPwdTips" : "Original password",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Смена привязанной эл. почты",
    "bindEmailSuccess" : "Привязанная эл. почта: \$email</br>Используйте для проверки привязанную эл. почту. После проверки вы можете изменить адрес эл. почты.",
    "reSetSecurityQuessoon" : "Секретные вопросы успешно установлены</br></br>Выберите разные вопросы и выполните проверку. Вопросы можно поменять после проверки.",
    "canotModifyTips" : "После подтверждения изменения НЕЛЬЗЯ будет отменить. Продолжить?",
    "rebindEmailTips" : "Ваш адрес эл. почты :\$email, нажмите, чтобы получить проверочный код.",
    "reGetVrfCode" : "Получить код",
    "findPwdWayTips" : "Выберите один из способов",
    "emailWay" : "Восстановить через эл. почту",
    "emailWayTips" : "Сбросить пароль можно будет, получив специальное сообщение на эл. почту",
    "quessionWay" : "Восстановить ответом на вопрос",
    "quessionWayTips" : "Сбросить пароль можно будет, правильно ответив на секретные вопросы",
    "resetPwdBtn" : "Сброс пароля",
    "lastStep" : "Предыдущее",
    "sendEmailTips" : "Мы отправили сообщение на эл. почту \$email.<br>Введите здесь проверочный код из сообщения.",
    "setNewPwdTips" : "Поздравляем!<br>Проверка пройдена, вы можете сбросить пароль.",
    "termsOfUse" : "Условия использования",
    "copy_success" : "Copied",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Select Type",
    "creatework_title" : "Subject",
    "creatework_titleHolder" : "Please enter a subject",
    "creatework_detail" : "подробности",
    "creatework_detailHolder" : "Description must not contain more than 200 characters",
    "creatework_uploadTips" : "Please upload jpg/png files only. Uploaded file must be smaller than 5 MB.",
    "creatework_selectBox_selectTile" : "Type",
    "creatework_goGame" : "Return",
    "creatework_history" : "History",
    "mylist_noYet" : "No record",
    "mywork_solved" : "Problem solved?",
    "mywork_service" : "Rate us",
    "mywork_messageHolder" : "New message",
    "mywork_score" : "Score",
    "mywork_confirm" : "CONFIRM",
    "creatework_selectBox_selectList3" : "Other",
    "creatework_selectBox_selectList2" : "Account",
    "close" : "Close",
    "creatework_gameHolder" : "Select Game",
    "creatework_serverHolder" : "Выберите сервер",
    "contactService" : "Служба поддержки",
    "FAQ" : "FAQ",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Character:",
    "selectRoleName" : "Select Character",
    "creatework_noRole" : "No character",
    "creatework_noGame" : "Game list is empty",
    "creatework_noServer" : "Server list is empty",
    "termText" : "I agree to {mainHost}",
    "backLogin" : "DECLINE",
    "creatework_roleHolder" : "Access after choosing your character",
    "findPwdFailTips" : "You have not set security questions. Please contact customer service.",
    "payMall" : "Mall",
    "selectPayment" : "количество",
    "plzSelectPayWay" : "выберите канал",
    "gainPlus" : "Bonus",
    "gainMorePlus" : "Add More",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Select Payment Method",
    "roleName" : "Character",
    "payWay" : "Payment Channel",
    "plzSelectOtherWay" : "Alternative Payment Channel",
    "payment" : "Amount",
    "compensateTips" : "Surplus will be returned to you in \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "In-game Currency",
    "compensate" : "Compensation",
    "payWayPlus" : "Channel Bonus",
    "neddPay" : "Payment",
    "submitOrder" : "Submit",
    "screenshotTips" : "Примечание: сделайте скриншот своего заказа на случай, если возникнут проблемы с транзакцией.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transaction failed. Please submit order again or contact our customer service.",
    "storeAcceptance" : "Processing",
    "storeSuccessTips" : "Транзакция будет выполнена в течение 15 минут.",
    "orderNumber" : "Номер заказа:",
    "buyProduct" : "Пополнение предмета",
    "transactionAmount" : "Amount",
    "failReason" : "Reason",
    "payOntherORder" : "Новый заказ",
    "reStore" : "Recharge Again",
    "confirm" : "Принять",
    "switch" : "Смена аккаунта",
    "completeTips" : "Укажите ваши личные данные. <mark class=\"yellowMarkColor\">Эту информацию нельзя будет изменить</mark>. Если захотите восстановить аккаунт, вам надо будет предоставить ваши личные данные.",
    "creatework_selectBox_selectList0" : "Game Error",
    "creatework_selectBox_selectList1" : "Payment Error",
    "creatework_selectBox_selectList4" : "Translation Error",
    "mywork_solvedText" : "Problem solved",
    "browserPayErrBtnText" : "Payment Error",
    "browserPaySucBtnText" : "Payment completed",
    "browserPayingTips" : "Redirecting to third-party platform.<br/>Can close this page after payment.",
    "price_list_empty" : "No applicable sum",
    "pointCardTips" : "Note: This item only supports \$paymentAmount card",
    "forgetPwd" : "Забыли пароль?",
    "payCenter" : "Recharge Center",
    "willGet" : "You will get",
    "goods" : "предмет",
    "discount" : "Bonus",
    "payDiscount" : "Compensation",
    "payDiscountTips" : "Extra points will be converted to Diamonds",
    "hasQuestionPlease" : "If you have any questions, please",
    "pwdValidateMsg" : "Password must contain 6 to 20 characters",
    "payWayPlusC" : "Channel Bonus",
    "fwtk" : "TERMS OF SERVICE",
    "yszc" : "PRIVACY POLICY",
    "exchange" : "Gift code exchange",
    "remember" : "запомнить мой выбор",
    "thirdInfo" : "About Account",
    "thirdInfoContent" : "Please bind your account in the in-game User Center. After that, log in the game using the bound account.",
    "unLink" : "This method is currently not supported",
    "favour" : "Bookmark",
    "goStoreTip" : "Please proceed to the payment page",
    "go" : "Go",
    "otherLogin" : "Other login methods",
    "qrCodeTip" : "Scan the QR code to get started!",
    "favourTip" : "Bookmark the page to play again later!",
    "share" : "Share",
    "landscapeTip" : "Please proceed in portrait mode",
    "leaveTip" : "Exit the game?",
    "selectRole" : "Пожалуйста, выберите персонажа",
    "selectMoney" : "Пожалуйста, выберите объект",
    "seletGameInfoFirst" : "Please choose game",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Код страны",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Запрос удаления аккаунта",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Укажите адрес эл. почты",
    "sendSuccess" : "Сообщение отправлено",
    "enterCode" : "Введите проверочный код",
    "errorCode" : "Неверный проверочный код",
    "selectQuest" : "Выберите секретный вопрос",
    "enterAnswer" : "Напишите ответ",
    "selectDifferQuest" : "Выберите 3 секретных вопроса и ответьте на них",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Политика конфиденциальности",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Congrats! Application approved! Please reset your profile.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Введите проверочный код",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Забыл пароль",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Если вышеуказанные методы не работают, то вы можете подать заявку на <span>восстановление аккаунта</span>",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Сменить на \${type}",
    "moreGame" : "more games",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Вы уверены, что хотите удалить аккаунт вместе с информацией о нём?",
    "account_delete_fwq" : "Сервер",
    "account_delete_zhm" : "Персонаж",
    "account_delete_jshflj" : "Ссылка на восстановление Персонажа",
    "account_delete_qzyzmdxx" : "(С учётом регистра)",
    "account_delete_jtbcysxx" : "Рекомендуем сделать снимок экрана с вышеуказанной информацией для восстановления аккаунта.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "анкета",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "О Наградах",
    "yourServer" : "Ваш Севрер",
    "allServer" : "Все Серверы",
    "h5_header_screen" : "Полный Экран",
    "h5_verticalTip" : "Рекомендуется альбомный режим.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Недавние",
    "moreGames" : "Ещё",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "по умолчанию",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Бонус за Способ Оплаты\nБонусная валюта = Выплаченная сумма*курс валюты * ставка бонуса х Бонус за Способ Оплаты\nБонусная валюта = Выплаченная сумма*курс валюты * бонусная ставка\n*Примечание: бонусная валюта не будет учитываться в событиях пополнения счёта или VIP-Опыте.*Для игр, запущенных по всему миру, сумма платежа рассчитывается в долларах США. Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки клиентов.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Если бы вы решили сохранить номер своей карты на предыдущей странице, мы бы собрали данные вашей карты (**** **** **** 1234) в зашифрованном виде.",
    "quickcard_result_tip_two" : "Мы храним зашифрованные данные лишь для вашего удобства — так при следующей покупке вам не нужно будет вводить номер карты.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Заявление о Сохранённых Учётных Данных",
    "quickcard_info_tip_one" : "Чтобы обеспечить более надежную защиту пользовательских данных, Visa и Mastercard вводят новые определения для «сохранённых учётных данных», а также новые правила для сохранённых учётных данных и транзакций, инициированных продавцом.",
    "quickcard_info_tip_two" : "Чтобы обеспечить более надежную защиту пользовательских данных, Visa и Mastercard вводят новые определения для «сохранённых учётных данных», а также новые правила для сохранённых учётных данных и транзакций, инициированных продавцом.\nКогда вы совершаете покупку на нашем веб-сайте, мы собираем данные вашей карты (1234 **** **** 1234) в зашифрованном виде. Мы будем хранить эти зашифрованные данные в течение 4 лет и в случае каких-либо изменений обновим соглашение и политику конфиденциальности на нашем веб-сайте. Мы храним зашифрованные данные только для вашего удобства, и при следующей покупке вам не нужно будет вводить данные карты.",
    "search_product" : "найти предмет",
    "search_price" : "найти стоимость",
    "price" : "стоимость",
    "product_no_found" : "No items are found",
    "price_no_found" : "No price are found",
    "search_no_found" : "No items/price are found",
    "product" : "item",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "использовать Множитель Ящиков?",
    "doubleSendInfo" : "Благодаря использованному «Множителю Ящиков», количество некоторых из приобретённых вами товаров было удвоено! (Обратите внимание на цифры внизу).",
    "storeRoleTitle" : "Выберите Персонажа",
    "storeSocialLogin" : "Войти через социальные сети",
    "storeAccountIdLogin" : "Войти с ID учётной записи",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Поиск",
    "storeSelectProductTitle" : "Выберите предметы",
    "storeInputNameSearch" : "Введите название предмета и выполните поиск",
    "storeInputPriceSearch" : "Введите цену предмета и выполните поиск",
    "storeNoFindProduct" : "Предмет не найден. Пожалуйста, попробуйте ещё раз.",
    "storePriceUp" : "Цена↑",
    "storePriceDown" : "Цена↓",
    "storeLookDetail" : "Подробности",
    "storeChangeProduct" : "Поменять Предмет",
    "storeWelcome" : "Добро пожаловать",
    "storeLookMore" : "Ещё",
    "storeHasSelect" : "Предмет выбран",
    "storeTotal" : "Всего",
    "storeExtra" : "Бонус",
    "storeProductDetail" : "Подробности",
    "storeUidGuideStep1" : "Нажмите «Настройки» > «Ещё» > «Учётная Запись»",
    "storeUidGuideStep2" : "Введите ID учётной записи при пополнении",
    "storeSelectAndLook" : "Сначала нужно выбрать персонажа",
    "storeSwitchWay" : "Изменить способ входа",
    "type1" : "Распродажа Дня",
    "type2" : "Герой",
    "type3" : "Боевое Снаряжение",
    "type4" : "",
    "type5" : "Чипы",
    "type6" : "Нова",
    "type7" : "Ресурсы",
    "type8" : "Ускорение Строительства",
    "type9" : "Редкие Предметы",
    "type10" : "Альянс",
    "type11" : "Алмаз",
    "type12" : "Модуль",
    "type13" : "Кубы",
    "type14" : "",
    "type15" : "Нанооружие",
    "type16" : "Главный Приз",
    "type17" : "",
    "type9999" : "Особые Предложения",
    "type10000" : "Центр Подарков",
    "type10001" : "Праздничные События",
    "typeother" : "Разное",
    "switchChar" : "Смена Персонажа",
    "howToFindUid" : "Как узнать ID моего аккаунта?",
    "choosePayWay" : "Выберите способ оплаты",
    "new_apple_deleteaccount_stepsub_title" : "Отменить автообновление",
    "new_apple_deleteaccount_stepsub_1" : "В вашей учётной записи включена функция автоматического обновления. Рекомендуем отключить автообновление прежде, чем удалять свою учётную запись, чтобы исключить риск нежелательных покупок.",
    "new_apple_deleteaccount_stepsub_2" : "Отменить автообновление",
    "new_apple_deleteaccount_stepsub_later" : "Позже",
    "new_apple_deleteaccount_stepsub_now" : "Сейчас",
    "new_apple_deleteaccount_title" : "Отправить запрос на удаление аккаунта",
    "new_apple_deleteaccount_step1_1" : "Пожалуйста, внимательно прочитайте пользовательское соглашение:",
    "new_apple_deleteaccount_step1_2" : "Ваша учетная запись будет  <span class=\"highlight\">безвозвратно удалена.</span> Вы НЕ сможете использовать её для входа в игру. Вся удаленная информация о вашей учетной записи не подлежит восстановлению.",
    "new_apple_deleteaccount_step1_3" : "Если вы хотите отвязать свой аккаунт от сторонней учетной записи, пожалуйста, свяжитесь со службой поддержки перед удалением аккаунта. В противном случае, после успешного удаления вашего аккаунта, вы не сможете использовать привязанную к нынешнему аккаунту стороннюю учетную запись для последующего входа в игру. Пожалуйста, также убедитесь, что вы правильно распорядились своими внутриигровыми активами, прежде чем подавать заявку на удаление вашей учетной записи.",
    "new_apple_deleteaccount_step1_4" : " <span class=\"highlight\">Если вы хотите подать заявку на возврат средств, настоятельно рекомендуем сделать это до удаления своего аккаунта.</span> Пожалуйста, убедитесь, что вы правильно распорядились своими внутриигровыми активами, прежде чем удалять свой аккаунт.",
    "new_apple_deleteaccount_step2_1" : "Вы уже распорядились своими внутриигровыми активами? Если вы этого ещё не сделали, пожалуйста, свяжитесь со службой поддержки по этому вопросу, прежде чем отправлять запрос на удаление учетной записи.",
    "new_apple_deleteaccount_step2_2" : "Пожалуйста, введите «Delete» («Удалить»), чтобы завершить удаление. После выполнения данного действия удаление аккаунта нельзя будет отменить.",
    "new_apple_deleteaccount_step2_3" : "Пожалуйста, введите «Delete» («Удалить»), чтобы завершить удаление",
    "new_apple_deleteaccount_step3_1" : "Запрос на удаление вашего аккаунта принят. Данные удалённой учётной записи:",
    "new_apple_deleteaccount_step3_2" : "Чтобы вновь войти в игру, пожалуйста, создайте новую учетную запись.",
    "new_apple_deleteaccount_step4_1" : "Вы удалили свою старую учетную запись. Чтобы вновь войти в игру, создайте новую учётную запись.",
    "currencyTypeName" : "Валюта",
    "has_select_product" : "Ваши Предметы:",
    "n_product" : "\${n}",
    "look_detail_product" : "Просмотреть Всё",
    "limit_buy_product" : "Лимит покупок этого предмета: \${n}",
    "limit_order" : "За один раз можно приобрести не более \${n} предметов.",
    "limit_order_remove_tip" : "Достигнут лимит покупок некоторых предметов в этой корзине. Удалить их?",
    "paytype_limit" : "Этот способ оплаты не может быть использован для покупки некоторых из выбранных вами предметов. Пожалуйста, выберите другой способ оплаты или попробуйте приобрести их отдельно.",
    "check_remove_cart" : "Удалить из корзины?",
    "remove_cart" : "Удалить",
    "confirm_product" : "Подтвердить",
    "select_paytype" : "Выберите способ оплаты",
    "cart_is_empty_tip" : "Ничего не найдено. Сначала нужно выбрать желаемый предмет.",
    "thirty_tip" : "Если вы не получите приобретенные предметы в течение 30 минут, свяжитесь с нашей службой поддержки.",
    "total_n_product" : "Предметов: \${n}",
    "look_detail_of_cart" : "Просмотреть Все",
    "order_detail" : "Список Предметов",
    "total_detail" : "Количество:",
    "add_to_cart" : "Добавить в Корзину",
    "back_to_select" : "Назад",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Confirm",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Зайти \nна Сайт",
    "visitorLogin" : "Гость",
    "tokenLogin" : "Одноразовый Пароль",
    "fbLogin" : "Войти с помощью Facebook",
    "googleLogin" : "Войти с помощью Google",
    "twitterLogin" : "Войти с помощью Twitter",
    "vkLogin" : "Войти с помощью VK",
    "agreementTextStart" : "Входя в игру, вы подтверждаете, что прочитали и согласны с Условиями предоставления услуг и Политикой конфиденциальности.",
    "userCenter" : "Центр Пользователя",
    "welcomeBack" : "С возвращением!",
    "continueGame" : "НАЧАТЬ",
    "officialPay" : "Центр Пополнения",
    "changeAccount" : "Смена Аккаунта",
    "back" : "Назад",
    "tokenKey" : "Одноразовый Пароль",
    "inputUid" : "Введите ID пользователя",
    "inputToken" : "Введите одноразовый пароль",
    "inputCkCode" : "Введите текст",
    "enterGame" : "НАЧАТЬ",
    "tokenTip" : "Защитите свою учетную запись с помощью верификации через одноразовый пароль",
    "howToGetToken" : "Как получить одноразовый пароль?",
    "getStep1" : "Шаг 1: Нажмите «Настройки» - «Аккаунт» - «Центр Пользователя»",
    "getStep2" : "Шаг 2: Нажмите «Одноразовый Пароль»",
    "getStep3" : "Шаг 3: Скопируйте и введите свой ID пользователя и одноразовый пароль",
    "copy" : "Копировать",
    "lastRefresh" : "Обновление ч-з:",
    "second" : "сек.",
    "immediatelyRefresh" : "Обновить",
    "frequently" : "Операция происходит слишком часто. Пожалуйста, попробуйте позже.",
    "loginFail" : "Не удалось войти. Неверный пароль.",
    "tokenIntro" : "Об одноразовом пароле (OTP)",
    "tokenIntro1" : "1. Одноразовый пароль действителен в течение 120 секунд после получения. Используйте его с умом и защитите свою учетную запись.",
    "tokenIntro2" : "2. Сотрудники  никогда не будут запрашивать у вас одноразовый пароль. Пожалуйста, ни с кем не делитесь своим паролем.",
    "nextStep1" : "Confirm",
    "couponCanUse" : "Доступно",
    "couponCanNotUse" : "Недоступно",
    "couponHasNoCoupon" : "Купонов нет",
    "couponUseTip" : "Для каждого заказа можно использовать только 1 купон",
    "couponValidTime" : "Период действия",
    "couponFuilCanUse" : "Используется для заказов на сумму свыше  \${price} \${currency}",
    "couponNoLimit" : "Без ограничений",
    "couponAllProductCanUse" : "Все предметы",
    "couponPartProductCanUse" : "Конкретные предметы",
    "couponPartPaytypeCanUse" : "Конкретные платежные каналы",
    "couponOnlyCoinCanUse" : "Только для внутриигровой валюты",
    "couponOnlyDiamondCanUse" : "Только для алмазов",
    "couponOnlyPackageCanUse" : "Только для наборов",
    "couponOnlySubCanUse" : "Только для подписок",
    "couponOnlyDaibiCanUse" : "Только для токенов",
    "couponMaxDiscount" : "Скидка до \${price} \${currency}",
    "couponHasUsed" : "Использовано",
    "couponReductionType" : "Вычет",
    "couponDiscountType" : "Скидка",
    "couponUseNow" : "Использовать",
    "couponHasNoSelect" : "Купон не выбран",
    "couponHasSelectQuan" : "Скидка",
    "couponSubmitTip" : "Купоны будут использованы",
    "couponCanUseQuan" : "Купоны",
    "couponOrderTotal" : "Сумма заказа",
    "couponHasDiscount" : "Скидка",
    "couponPayTotal" : "Оплата",
    "couponCancel" : "Отмена",
    "couponConfirm" : "Принять",
    "uidLoginName" : "Войти по одноразовому паролю",
    "uidToken" : "Одноразовый Пароль",
    "uidInputUid" : "Введите ID пользователя",
    "uidInputToken" : "Введите одноразовый пароль",
    "uidInputCode" : "Введите текст",
    "uidTipTitle" : "Защитите свою учетную запись с помощью верификации через одноразовый пароль",
    "uidTipHowToGet" : "Как получить одноразовый пароль?",
    "uidTipStep1" : "Шаг 1: Нажмите «Настройки» - «Аккаунт» - «Центр Пользователя»",
    "uidTipStep2" : "Шаг 2: Нажмите «Одноразовый Пароль»",
    "uidTipstep3" : "Шаг 3: Скопируйте и введите свой ID пользователя и одноразовый пароль",
    "uidTipIntro1" : "1. Одноразовый пароль действителен в течение 60 секунд после получения. Используйте его с умом и защитите свою учетную запись.",
    "uidTipIntro2" : "2. Сотрудники  никогда не будут запрашивать у вас одноразовый пароль. Пожалуйста, ни с кем не делитесь своим паролем.",
    "couponMyQuan" : "Купоны",
    "couponSelectPaytypeTip" : "Выберите платежный канал, чтобы просмотреть информацию о скидке",
    "couponSelectCouponTip" : "Выберите купоны, чтобы узнать цену со скидкой",
    "couponValidQuanTip" : "(Доступные купоны: x\${num})",
    "couponLookCart" : "Корзина",
    "couponUnfoldCart" : "Скрыть",
    "couponCoupon" : "Купон",
    "couponNoUse" : "Не используется",
    "couponSelect" : "Выбор Купона",
    "couponSureUse" : "Использовать",
    "couponReturn" : "Назад",
    "couponInvalidTime" : "Истекает",
    "couponBuyNow" : "Купить Сейчас",
    "couponAllType" : "all",
    "ztmslgType1" : "Распродажа Дня",
    "ztmslgType2" : "Герой",
    "ztmslgType3" : "Боевое Снаряжение",
    "ztmslgType4" : "",
    "ztmslgType5" : "Чипы",
    "ztmslgType6" : "Нова",
    "ztmslgType7" : "Ресурсы",
    "ztmslgType8" : "Ускорение Строительства",
    "ztmslgType9" : "Редкие Предметы",
    "ztmslgType10" : "Альянс",
    "ztmslgType11" : "Алмаз",
    "ztmslgType12" : "Модуль",
    "ztmslgType13" : "Кубы",
    "ztmslgType14" : "",
    "ztmslgType15" : "Нанооружие",
    "ztmslgType16" : "Главный Приз",
    "ztmslgType17" : "Ядро",
    "ztmslgType9999" : "Особые Предложения",
    "ztmslgType10000" : "Центр Подарков",
    "ztmslgType10001" : "Праздничные События",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Распродажа",
    "antslgType2" : "Особый муравей",
    "antslgType3" : "Снаряжение",
    "antslgType5" : "Ген",
    "antslgType6" : "Улитка",
    "antslgType7" : "Ресурсы",
    "antslgType8" : "Стройка и наука",
    "antslgType9" : "Редкие предметы",
    "antslgType10" : "Альянс",
    "antslgType11" : "Алмаз",
    "antslgType12" : "Клетка",
    "antslgType13" : "Тотем",
    "antslgType9999" : "Супер сделка",
    "antslgTypeother" : "other",
    "typeall" : "Все товары",
    "vipHead" : "Очки VIP",
    "vipHead213": "Премиум участники",
    "vipTitle" : "Событие «Очки VIP»",
    "nowLevel" : "Ваш уровень:",
    "myVipScore" : "Ваши очки:",
    "nextLevelNeed" : "(Заработайте ещё \${num} очков, чтобы достичь VIP \${level})",
    "ruleTitle" : "Правила:",
    "ztmslgVipRule1" : "1. Событие начнётся 22-го сентября в 00:00 по UTC",
    "ztmslgVipRule2" : "2. Доступные игры:  Puzzles & Survival",
    "ztmslgVipRule3" : "Каждый тип наград можно получить только один раз.",
    "ztmslgVipRule4" : "3. Событие входного купона: при первом посещении страницы пополнения счета вы сможете получить купон со скидкой 15%.",
    "ztmslgVipRule5" : "4. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "ztmslgVipRule6" : "5. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "ztmslgVipRule7" : "6. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "ztmslgVipRule8" : "7. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "ztmslgVipRule9" : "8. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "ztmslgVipRule10" : "9. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "ztmslgVipRule11" : "10. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "ztmslgVipRule12" : "11. Ознакомьтесь с таблицей ниже, чтобы узнать подробнее об уровнях VIP и купонах.",
    "ztmslgVipRule13" : "12. В случае возникновения каких-либо споров команда «Puzzles & Survival» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "vipLevel" : "Уровень VIP",
    "vipCondition" : "Нужно очков:",
    "firstSend" : "Подарок за 1-е достижение",
    "weeklySend" : "Еженедельный купон",
    "lastAllCoupon" : "Предыдущие купоны",
    "besides" : "Таблица Валют/Очков:",
    "couponRatio" : "Соотношение Валют/Очков",
    "backToPay" : "НАЗАД",
    "quanGift" : "КУПОН",
    "quanGiftTips" : "У вас есть новые купоны!",
    "antslgVipRule1" : "В связи с обновлением функции, событие «VIP пункты» скоро прекратится.",
    "antslgVipRule2" : "Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.",
    "antslgVipRule3" : "Время окончания: 2024/09/28 00:00:00 (UTC)",
    "antslgVipRule4" : "После завершения события вы сможете посетить Центр премиум участников и получить бонусы:",
    "antslgVipRule5" : "Выполняйте квесты, чтобы зарабатывать очки и обменивать их на купоны, игровые предметы и прочие награды! Наслаждайтесь эксклюзивными преимуществами и попытками розыгрыша призов.",
    "antslgVipRule6" : "Оставайтесь на связи! Впереди много наград и событий!",
    "dzgVipRule0" : "1. Событие начнётся 27-го сентября в 00:00 по UTC",
    "dzgVipRule1" : "1. Доступные игры:  \${gameName}",
    "dzgVipRule2" : "Каждый тип наград можно получить только один раз.",
    "dzgVipRule3" : "2. Событие входного купона: при первом посещении страницы пополнения счета вы сможете получить купон со скидкой 15%.",
    "dzgVipRule4" : "3. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "dzgVipRule5" : "4. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "dzgVipRule6" : "5. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "dzgVipRule7" : "6. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "dzgVipRule8" : "7. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "dzgVipRule9" : "8. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "dzgVipRule10" : "9. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "dzgVipRule11" : "10. Ознакомьтесь с таблицей ниже, чтобы узнать подробнее об уровнях VIP и купонах.",
    "dzgVipRule12" : "11. В случае возникновения каких-либо споров команда «\${gameName}» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "213dzgVipRule1" : "В связи с обновлением функции, событие «VIP пункты» скоро прекратится.",
    "213dzgVipRule2" : "Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.",
    "213dzgVipRule3" : "Время окончания: 2024/08/19 08:00:00 (UTC)",
    "213dzgVipRule4" : "После завершения события вы сможете посетить Центр премиум участников и получить бонусы:",
    "213dzgVipRule5" : "Выполняйте квесты, чтобы зарабатывать очки и обменивать их на купоны, игровые предметы и прочие награды! Наслаждайтесь эксклюзивными преимуществами и попытками розыгрыша призов.",
    "213dzgVipRule6" : "Оставайтесь на связи! Впереди много наград и событий!",
    "getReward" : "эксклюзивные рамки для аватара",
    "unbindEntry" : "Привязка / Отвязка Уч. Записи",
    "unbindApply" : "Отвязать",
    "unbindConfirmTitle" : "Вы точно хотите отвязать учётную запись?",
    "unbindConfirmTip" : "Отвязка учётной записи может привести к потере прогресса в игре.",
    "unbindConfirm" : "Всё равно отвязать",
    "unbindExit" : "Выйти",
    "unbindSucc" : "Отвязка прошла успешно",
    "unbindFail" : "Отвязка уч. записи не удалась. Пожалуйста, напишите в нашу Службу Поддержки.",
    "unbindServiceTitle" : "Пожалуйста, подайте заявку на ручную отвязку учётной записи.",
    "unbindContact" : "Служба Поддержки",
    "unbindServiceTip" : "Вы не можете отвязать свою учётную запись. Пожалуйста, напишите в нашу Службу Поддержки.",
    "antslgType15" : "Наследие",
    "shareEventTitle" : "Приглашайте Друзей</br>Получайте Награды",
    "shareRule" : "Правила",
    "awardBag" : "Моя Награда",
    "initiatorText" : "Я приглашающий",
    "inviteeText" : "Я приглашённый",
    "createCode" : "Придумайте Код Приглашения",
    "createCodeTip" : "Нажмите, чтобы создать код приглашения",
    "createLinkTip" : "Нажмите, чтобы создать ссылку для приглашения",
    "copyText" : "Копировать",
    "shareCode" : "Поделитесь Кодом Приглашения",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Просмотрите Награду",
    "seeAwardTip" : "Вы можете увидеть свои награды, нажав <span class=\"see-light\">«Пункты VIP»</span> > <span class=\"see-light\">«Мои Купоны»</span>.",
    "inviteReward" : "Награда за Приглашение",
    "inviteRewardTip" : "Приглашающий может забрать эти награды, когда каждый приглашённый им игрок впервые достигнет этих целей",
    "overweightReward" : "Бонусная Награда",
    "resetTip" : "Сбрасывается в 00:00 в последний день каждого месяца.（UTC+0）",
    "rewardText1" : "Общее Пополнение Приглашённого: \$9.99",
    "rewardText2" : "Общее Пополнение Приглашённого: \$49.99",
    "rewardText3" : "Общее Пополнение Приглашённого: \$99.99",
    "rewardText4" : "Получите купон на скидку 12% x1 за каждые 5 приглашенных игроков",
    "rewardText5" : "Получите купон на скидку 15% x1 после того, как приглашенные вами игроки совершат пополнение на сумму 1000 \$",
    "invitationList" : "Моё Приглашение",
    "refresh" : "Обновить",
    "invitedTotal" : "Приглашено: \${total}",
    "storedTotal" : "Общее Пополнение: \${total} USD",
    "people" : "",
    "invitedPeople" : "Приглашённый",
    "invitedTime" : "Приглашен(а)",
    "got" : "Достигнуто",
    "get" : "Не достигнуто",
    "overlay" : "Складывается",
    "couponText" : "Купон",
    "personalReward" : "Награда за Пополнение",
    "personalRewardText1" : "Общее Пополнение достигает \$9.99",
    "personalRewardText2" : "Общее Пополнение достигает \$49.99",
    "personalRewardText3" : "Общее Пополнение достигает \$99.99",
    "inputCode" : "Введите код приглашения",
    "bindCode" : "Подтвердить",
    "bindSucc" : "Привязан",
    "codeTip1" : "Код не существует.",
    "codeTip2" : "Код Приглашения Привязан",
    "copySucc" : "Успех!",
    "awardName" : "Награда",
    "getTime" : "Получено",
    "getCondition" : "Требования",
    "couponText1" : "Купон на 6% скидку",
    "couponText2" : "Купон на 8% скидку",
    "couponText3" : "Купон на 10% скидку",
    "couponText4" : "Купон на 12% скидку",
    "couponText5" : "Купон на 15% скидку",
    "ruleText1" : "1. Начало события: 25/11/2022, 00:00 по UTC",
    "ruleText2" : "2. Игра: «Puzzles & Survival»",
    "ruleText3" : "3. Событие «Поделись Официальным Сайтом для Пополнения»: Поделитесь официальным сайтом для пополнения со своими друзьями и пригласите их пополнить счёт. Если они пополнят счёт на определённую сумму на этой странице, вы получите награду.",
    "ruleText4" : "4. Ежемесячные Награды за платежи на стороннем сайте: Поделитесь этой страницей определённое количество раз в течение месяца, чтобы получить награды. Все награды сбрасываются раз в месяц.",
    "ruleText5" : "5. Для получения Ежемесячной Награды нужен хотя бы один успешный платёж, совершённый на стороннем сайте приглашёнными вами новыми игроками.",
    "ruleText6" : "6. Ежемесячные Награды сбрасываются в первый день каждого месяца. Весь прогресс предыдущего месяца также обнуляется.",
    "ruleText7" : "7. Вознаграждение в виде купона можно получить, совершив вход на сторонний сайт для пополнения. По истечении срока действия купона нельзя получить новый купон.",
    "ruleText8" : "8. Вы получите купон в той же валюте, которую вы использовали при предыдущих пополнениях.",
    "ruleText9" : "9. Вы не можете использовать код приглашения другого игрока, если он уже использовал ваш.",
    "ruleTableTitle1" : "Правила：",
    "ruleTableTitle2" : "О VIP-уровнях и Купонах:",
    "ruleTableHead1" : "Требования для Пополнения",
    "ruleTableHead2" : "Требования для Получения Наград",
    "ruleTableHead3" : "Награды",
    "ruleTableContent1" : "Пригласите 5 новых игроков",
    "ruleTableContent2" : "Приглашённые игроки должны совершить платежи на 1000\$",
    "errorTip" : "Операция не удалась",
    "eventShareText1" : "«Puzzles & Survival»: Ограниченные Предложения",
    "eventShareText2" : "Вас Ждёт Множество Подарков!",
    "cartDoubleTip" : "Множители Ящиков не поддерживаются.",
    "codeTip3" : "Вход не выполнен",
    "codeTip4" : "Параметр отсутствует",
    "codeTip5" : "Нельзя привязать собственный код приглашения",
    "codeTip6" : "Код приглашения создан",
    "payWelfare" : "Подарок за Пополнение",
    "wallet" : "Кошелёк",
    "myDiscount" : "Мои Купоны",
    "knowMore" : "Ещё",
    "backPay" : "Назад",
    "curBalance" : "Баланс",
    "pay" : "Пополнение",
    "changeCoin" : "Изменить Валюту",
    "watchDesc" : "Узнать Детали",
    "getMore" : "Получить Ещё",
    "getDiscount" : "Заберите Свои Купоны",
    "notOpenDiscountQuan" : "Пока нет событий. Следите за новостями!",
    "abountZbit" : "О \${Z-BIT}",
    "remain" : "Осталось:",
    "payRemain" : "Сумма, оставшаяся после покупки:",
    "payRemainExpiry" : "После оплаты: ${money} (Срок действия: 1 января 2026 г. Поторопитесь использовать!)",
    "balanceNotEnoughExpiry" : "Не хватает средств (Истекает 01.01.2026, пополнение недоступно)",
    "balanceNotEnoggh" : "На балансе недостаточно средств. Сначала пополните счёт.",
    "goToPay" : "Пополнение",
    "chooseOtherPay" : "Другие Способы Оплаты",
    "payIntro" : "Детали Пополнения",
    "logRole" : "Выберите Персонажа",
    "chooseProduct" : "Выберите Предметы",
    "meAgree" : "Я прочитал(-а) и согласен(-на) с условиями.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Перед использованием \${Z-BIT} требуется динамическая верификация",
    "dl3dvnVipRule1" : "1. Доступные игры:  \${gameName}",
    "dl3dvnVipRule2" : "Каждый тип наград можно получить только один раз.",
    "dl3dvnVipRule3" : "2. Событие входного купона: при первом посещении страницы пополнения счета вы сможете получить купон со скидкой 15%.",
    "dl3dvnVipRule4" : "3. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "dl3dvnVipRule5" : "4. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "dl3dvnVipRule6" : "5. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "dl3dvnVipRule7" : "6. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "dl3dvnVipRule8" : "7. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "dl3dvnVipRule9" : "8. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "dl3dvnVipRule10" : "9. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "dl3dvnVipRule11" : "10. Ознакомьтесь с таблицей ниже, чтобы узнать подробнее об уровнях VIP и купонах.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. В случае возникновения каких-либо споров команда «\${gameName}» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "codeTip7" : "Не удаётся использовать код целевого игрока, т.к. он/она уже использовал(а) ваш",
    "ruleText10" : "10. Официальное руководство «Puzzles & Survival» оставляет за собой право на окончательную интерпретацию правил.",
    "payCoins" : "Пополнение: Пункты VIP",
    "shareGift" : "Делитесь и Получайте Подарки",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "В выбранном регионе нет доступных способов оплаты. Пожалуйста, смените регион и повторите попытку.",
    "dl3dtwVipRule1" : "1. Доступные игры:  \${gameName}",
    "dl3dtwVipRule2" : "Каждый тип наград можно получить только один раз.",
    "dl3dtwVipRule3" : "2. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "dl3dtwVipRule4" : "3. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "dl3dtwVipRule5" : "4. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "dl3dtwVipRule6" : "5. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "dl3dtwVipRule7" : "6. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "dl3dtwVipRule8" : "7. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "dl3dtwVipRule9" : "8. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "dl3dtwVipRule10" : "9. Ознакомьтесь с таблицей ниже, чтобы узнать подробнее об уровнях VIP и купонах.",
    "dl3dtwVipRule11" : "10. В случае возникновения каких-либо споров команда «\${gameName}» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "eventInviteSucc" : "Успешное Приглашение Друга",
    "eventGainCondition" : "Требования",
    "eventSuccInvite" : "Успешное приглашение друга",
    "eventInviteGainOne" : "Общее Пополнение \nПриглашённого: \$49.99",
    "eventInviteGainTwo" : "Общее Пополнение \nПриглашённого: \$99.99",
    "eventFriendCode" : "Код Вашего Друга:",
    "eventCheckBind" : "Привязать?",
    "eventConfirm" : "Подтвердить",
    "eventCancel" : "Отменить",
    "eventBindSucc" : "Привязка прошла успешно!",
    "eventGainCoupon" : "Вы получили купон.",
    "eventLookCoupon" : "Обзор Купонов",
    "eventSuccBind" : "Привязка прошла успешно",
    "recaptchaTip" : "Пожалуйста, сначала пройдите верификацию",
    "inputAccountName" : "Введите название уч. записи, которую хотите восстановить",
    "pwaPayTip" : "Быстрый доступ, лучшие впечатления",
    "pwsInstall" : "Добавить на Главный экран",
    "ztmslgType999" : "Ваучер",
    "coinUseTips" : "Une fois achetés, les Coupons seront envoyés dans votre boîte aux lettres en jeu. Les Coupons peuvent être utilisés pour acheter des objets dans le Centre Commercial de Coupon en jeu. Les Coupons utilisés pour acheter des objets seront comptabilisés dans le total de votre recharge.",
    "notice" : "Уведомление",
    "popupConfirm" : "Принять",
    "hideWithinWeek" : "Не показывать 7 дней",
    "ztmslgProductOffTips" : "Мы получили много отзывов касательно изменений для страницы оплаты, которые мы планировали внедрить 13 марта. В ответ на ваши сообщения, мы решили отказаться от этих изменений и сосредоточиться на повышении удобства ваших покупок. Спасибо за понимание и поддержку, ваше мнение очень важно для нас. Если у вас есть какие-либо вопросы, пожалуйста, напишите в нашу службу поддержки клиентов.",
    "couponTopLimit" : "Максимальные суммы вычета от валюты",
    "swsjpVipRule1" : "1. Event starts at 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2. Доступные игры: \${gameName}",
    "swsjpVipRule3" : "Каждый тип наград можно получить только один раз.",
    "swsjpVipRule4" : "3. Событие входного купона: при первом посещении страницы пополнения счета вы сможете получить купон со скидкой 15%.",
    "swsjpVipRule5" : "4. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "swsjpVipRule6" : "5. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "swsjpVipRule7" : "6. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "swsjpVipRule8" : "7. Очки за ваши прошлые покупки начисляются вам автоматически.",
    "swsjpVipRule9" : "8. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "swsjpVipRule10" : "9. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "swsjpVipRule11" : "10. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "swsjpVipRule12" : "11. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "swsjpVipRule13" : "12. В случае возникновения каких-либо споров команда «\${gameName}» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Билет",
    "passAskMods" : "Спросить модера",
    "passAskModsTip" : "Задать вопрос модератору об игре",
    "passService" : "Служба поддержки",
    "passServiceTip" : "Свяжитесь со службой поддержки по вопросам, связанным с аккаунтом и пополнением счёта.",
    "passIKonw" : "Принять",
    "passGoOn" : "Продолжить",
    "voucherTitle" : "Официальный центр покупок",
    "voucherAddHome" : "Добавить на рабочий стол",
    "voucherAddHomeTipOne" : "Быстрые платежи, удобная оплата",
    "voucherAddHomeTipTwo" : "Нажмите [Поделиться] на панели",
    "voucherAddHomeTipThree" : "Выберите [Добавить на рабочий стол]",
    "voucherLoginLook" : "Войдите и изучите акции",
    "voucherSwitchRole" : "Сменить персонажа",
    "voucherCoupon" : "Купон",
    "voucherVip" : "Очки VIP",
    "voucherMoreCoupon" : "Больше акций",
    "voucherAccountId" : "ID аккаунта",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Выберите другой способ оплаты",
    "voucherOtherLoginWay" : "Попробовать другой способ",
    "voucherCouponActivity" : "Распродажи",
    "voucherActivityNotBegin" : "Событие ещё не началось.",
    "voucherGoCommunity" : "Узнайте в сообществе больше о преимуществах покупок",
    "voucherValidTime" : "Срок действия",
    "voucherLimitRegion" : "Только для \${currency}",
    "voucherLiuyi" : "Нет доступных купонов. Пожалуйста, ожидайте следующих акций.",
    "voucherPay" : "Купить ваучеры",
    "voucherAbout" : "О ваучерах",
    "voucherChooseWay" : "Выбор способа оплаты",
    "voucherMoreWay" : "Больше способов оплаты",
    "voucherChooseCoupon" : "Выбор купона",
    "voucherHasChoose" : "Выбрано",
    "voucherMoneyInsufficient" : "Недостаточно средств",
    "voucherContact" : "Недостаточно средств. Пожалуйста, свяжитесь с нашей службой поддержки.",
    "voucherCouponTotal" : "Доступные купоны",
    "voucherCouponTipGuide" : "Купоны можно использовать для покупки после выбора платёжного канала.",
    "voucherPaytypeNotSupport" : "Купоны недоступны для этого платёжного канала",
    "voucherTipSideOne" : "Ваучеры можно обменивать на любые игровые наборы и дополнительные сервисы, исключая сами ваучеры.",
    "voucherTipSideTwo" : "Скидка до 15%",
    "voucherYue" : "Баланс",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Руководство выжившего",
    "vipHeadText" : "Доступна эксклюзивная VIP-рамка",
    "vipHeadGetText" : "Получить",
    "vipHeadGotText" : "Получено",
    "vipHeadGetTitle" : "Принять",
    "vipHeadGetTip" : "Награду можно получить один раз на каждый аккаунт. Продолжить?",
    "vipHeadAwardText" : "Элитный командир (навсегда)",
    "vipHeadGetErrTip1" : "Не выполнено. Повторите попытку или напишите в службу поддержки.",
    "cartGuideTipNew" : "Ajouter plus d\'objets pour utiliser le coupon",
    "newVipTitle" : "Центр покупок VIP",
    "newVipLogin" : "ВХОД",
    "newVipNowPoint" : "Пункты:",
    "newVipNextLevel" : "\${point} пунктов до след. уровня",
    "newVipUpgrade" : "УЛУЧШИТЬ",
    "newVipLevel" : "Привилегии VIP",
    "newVipTip" : "Купоны обновляются в 00:00 (UTC) по субботам. Вы получите их после посещения официальной страницы пополнения счета.",
    "newVipWeekly" : "Недельный подарок",
    "newVipReachPoint" : "Требования:",
    "newVipRuleInfo" : "Правила:",
    "pleaseLang" : "Выберите язык",
    "reference" : "Номер заказа",
    "saveToNext" : "Сохранить данные кредитной карты.",
    "cardNum" : "Номер карты",
    "expireTime" : "Срок действия",
    "CVV" : "CVV",
    "pleaseCard" : "Тип кредитной карты",
    "howToPay" : "Как вы предпочитаете платить?",
    "checkCard" : "Проверьте номер кредитной карты.",
    "checkExpiryDate" : "Проверьте срок действия кредитной карты.",
    "checkCVV" : "Проверьте CVV кредитной карты.",
    "addCard" : "Новая",
    "delete" : "Удалить",
    "deleteCardTips" : "Удалить данные сохранённой кредитной карты.",
    "confirmDelete" : "Да, удалить",
    "cancelDelete" : "Отменить",
    "checkAllCardMsg" : "Убедитесь, что вы ввели верные данные карты, срок её действия и код CVV.",
    "leaveCreditPageTips" : "La transacción no se completará si abandona la página. ¿Salir de todos modos?",
    "sureToLeave" : "Salir",
    "continueToPay" : "Continuar",
    "pushTest" : "Проверка уведомлений",
    "getNoticication" : "Не приходят игровые уведомления?",
    "waitCheckResult" : "Подождите результатов проверки.",
    "hadAbnormal" : "Проблемы, которые могут привести к блокировке уведомлений.",
    "clickIntro" : "Проверьте отчёт, чтобы решить проблему",
    "networkCheck" : "Проверка сети",
    "noticeAuthorityCheck" : "Проверка доступа",
    "noticeBtnCheck" : "Проверка статуса",
    "gmsCheck" : "Проверка GMS-службы",
    "batteryCheck" : "Проверка батареи",
    "pushServiceCheck" : "Проверка уведомлений",
    "reCheck" : "Повторная проверка",
    "noNoticeAuthorityTip" : "На устройстве не гарантирован доступ к уведомлениям. Перейдите в «Настройки системы» - «Уведомления» и разрешите доступ.",
    "noNoticeBtnTip" : "Статусная строка уведомлений неактивна. Перейдите в «Настройки системы» - включите строку уведомлений.",
    "noBatteryTip" : "Игра включена в список оптимизации батареи. Перейдите в «Настройки системы» - «Батарея» - «Оптимизация» и исключите игру из списка оптимизации.",
    "noPushServiceTip" : "Сервер уведомлений неактивен. Нажмите [Подключиться], чтобы подключиться к серверу.",
    "noNetworkTip" : "Текущее сетевое подключение нестабильно.",
    "noGmsTip" : "Ваше устройство не поддерживает GMS-службу. Используйте устройство, которое поддерживает GMS.",
    "pushConnectFail" : "Сервер уведомлений отключен.",
    "pushConnectSucc" : "Сервер уведомлений подключен.",
    "noGetPushTitle" : "Если уведомления не начали приходить, попробуйте выполнить следующие шаги:",
    "noGetPushContOne" : "1. Выйдите из игры и войдите повторно.",
    "noGetPushContTwo" : "2. Проведите [Проверку уведомлений], чтобы узнать, примет ли ваше текущее устройство тестовое уведомление.",
    "noGetPushContThree" : "3. Если вы получили тестовое уведомление, но остальные уведомления не приходят, войдите в игру «Настройки» – «Уведомления» и проверьте, какие уведомления включены и выключены.",
    "noGetPushContFour" : "4. Если уведомления не начали приходить, свяжитесь с нашей службой поддержки.",
    "getPushSucc" : "Ваше устройство получило тестовое уведомление. Функция уведомлений работает нормально!",
    "allCheckSucc" : "Проверка уведомлений пройдена. Проблемы не обнаружены!",
    "pushCheck" : "Проверка уведомлений",
    "useDirectPay" : "Использовать быструю проверку",
    "paypalFraudnetInfo" : "Безопасная оплата через PayPal",
    "goToSetting" : "Настройки",
    "retry" : "Повторить",
    "connect" : "Подключить",
    "canRebind" : "После отвязки можно будет снова привязать",
    "agreePlatform" : "Я согласен с: \${service} и \${privite}.",
    "sendGameNews" : "Подпишитесь на новостную рассылку.",
    "canNotBindEmail" : "После отвязки вы не сможете использовать эту эл. почту для входа в систему.",
    "canNotBindPhone" : "После отвязки вы не сможете использовать этот номер телефона для входа в систему.",
    "canChangeByEmail" : "С адресом эл. почты можно входить в систему на разных устройствах.",
    "canChangeByPhone" : "С номером телефона можно входить в систему на разных устройствах.",
    "loginSucc" : "Выполнен вход",
    "phoneHadBind" : "Номер телефона уже привязан. Хотите войти, используя его?",
    "emailHadBind" : "Адрес эл. почты уже привязан. Хотите войти, используя его?",
    "phoneNotBind" : "Номер телефона еще не привязан. Хотите создать новый аккаунт?",
    "emailNotBind" : "Адрес эл. почты еще не привязан. Хотите создать новый аккаунт?",
    "emailAccount" : "Аккаунт (эл. почта)",
    "phoneAccount" : "Аккаунт (телефон)",
    "phoneInputError" : "Неверный номер телефона",
    "registerNewAccount" : "Регистрация",
    "secureTip" : "Советы по Безопасности Учётной Записи",
    "toTop" : "Прикрепить",
    "createNewWork" : "Новый запрос",
    "serviceEvaluate" : "Оценить работу",
    "emailRemind" : "Уведомления",
    "isAgreeService" : "Вам понравилась служба поддержки?",
    "thankEvaluateTop" : "Спасибо за ваш отзыв!",
    "inputValidEmail" : "Введите действительный адрес эл. почты.",
    "replyWillRemind" : "На эту эл. почту вы получите уведомление, когда мы ответим на ваш вопрос. Коснитесь еще раз, чтобы отключить.",
    "isCancelEmailRemind" : "Вы не будете получать уведомления на эл. почту. Хотите выключить?",
    "reconfirmEmail" : "Подтвердите адрес эл. почты.",
    "confirmCanSubmit" : "Подтвердите отправку запроса",
    "serviceWillReply" : "На эту эл. почту вы получите уведомление об ответе службы поддержки.",
    "cancelEmailRemind" : "Выключить [Уведомления]?",
    "yes" : "Да",
    "no" : "Нет",
    "inputWorkSearch" : "Поиск...",
    "loading" : "Загрузка...",
    "loadingError" : "Не удалось загрузить, повторите попытку...",
    "noMore" : "Больше ничего",
    "cancelToTop" : "Открепить",
    "evaluateOne" : "Очень плохо",
    "evaluateTwo" : "Плохо",
    "evaluateThree" : "Нейтрально",
    "evaluateFour" : "Хорошо",
    "evaluateFive" : "Очень хорошо",
    "confirmDelWorkTop" : "Удалить запрос?",
    "reRemindEmail" : "Подключить уведомления по эл. почте? Для этого нажмите кнопку [Уведомления].",
    "confirmWillReply" : "Подтвердите желание получать уведомления на эл. почту, когда мы ответим на ваш вопрос.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Удаленный запрос нельзя будет восстановить.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Видео загружено",
    "videoUploadFail" : "Не удалось загрузить видео",
    "videoUploadLimit" : "Загружайте видео в формате mp4 размером не более 400 Мб и длительностью не более 2 минут.",
    "imageUploadSucc" : "Картинка загружена",
    "imageUploadFail" : "Не удалось загрузить картинку",
    "uploading" : "Загружаем",
    "smartOrderCreate" : "Быстрый билет",
    "smartOrderSearch" : "Поиск",
    "smartOrderComing" : "Скоро появится",
    "smartOrderContactService" : "Служба поддержки",
    "smartOrderDetector" : "Помощник",
    "smartOrderDetect" : "Проверить",
    "smartOrderDetecting" : "Идёт проверка",
    "smartOrderDetectTip" : "Во время игры обнаружена проблема. Нажмите кнопку «Проверить», чтобы её определить.",
    "smartOrderDetectTip2" : "Проблема определена. Отправьте запрос, чтобы могли ее решить!",
    "smartOrderSubmit" : "Отправить",
    "smartOrderIKnow" : "Принять",
    "smartOrderConfirm" : "Принять",
    "smartOrderLook" : "Обзор",
    "smartOrderIsHelp" : "Статья была вам полезна?",
    "smartOrderInputQuestion" : "Опишите проблему, с которой вы столкнулись.",
    "smartOrderPleaseInpt" : "Ввести",
    "smartOrderPleaseChoose" : "Выбрать",
    "smartOrderStoreTime" : "Время пополнения",
    "smartOrderInputOrder" : "Укажите номер заказа",
    "smartOrderInputPrice" : "Укажите сумму заказа",
    "smartOrderNeedHelp" : "Чем я могу вам помочь?",
    "smartOrderLookHelpTip" : "Ознакомьтесь с разделом помощи.",
    "smartOrderNoResult" : "Ничего не найдено, попробуйте другое слово.",
    "smartOrderUpdateTime" : "Последняя правка",
    "smartOrderSelectStoreTime" : "Выберите время пополнения",
    "smartOrderAtlestChoose" : "Заполните хотя бы одно поле",
    "pwaInstallAward" : "Добавить ярлык",
    "getMasonry" : "Получить алмазы",
    "addToDrawerVisit" : "Добавьте ярлык, чтобы быстрее найти.",
    "immeAddToGet" : "Добавьте ярлык, чтобы получить особую награду.",
    "add" : "Добавить ярлык",
    "talkNextTime" : "Позже",
    "chooseRoleGetGift" : "Выберите персонажа для получения наград",
    "getGiftSuccess" : "Получено. Проверьте награду в игре.",
    "dmaTitle" : "Персонализ. реклама",
    "newAdd" : "Nuevo",
    "smartDelete" : "Eliminar",
    "wordLengthTip" : "(0-600 personajes)",
    "areaLimitSwitchRegion" : "Сменить регион",
    "areaLimitCurrentRegionCurrency" : "Текущий регион и валюта",
    "areaLimitRegion" : "Регион:",
    "areaLimitCurrency" : "Валюта:",
    "areaLimitNote" : "Примечание:",
    "areaLimitSwitchLimitation" : "Можно менять регион аккаунта один раз в год.",
    "areaLimitPostSwitchCoupon" : "После смены региона изменится и валюта новых купонов.",
    "areaLimitRemainingSwitches" : "Осталось попыток: \${times}",
    "areaLimitNoRemainingSwitches" : "Нет попыток смены",
    "areaLimitUnableToSwitchThisYear" : "В этом году вы не можете сменить регион.",
    "areaLimitCannotSwitch" : "Нельзя сменить",
    "areaLimitNavigateToSwitch" : "Сменить",
    "areaLimitConfirmSwitch" : "Принять",
    "areaLimitPreSwitchRegionCurrency" : "Текущий регион и валюта",
    "areaLimitPostSwitchRegionCurrency" : "Новый регион и валюта",
    "areaLimitPostSwitchRestriction" : "Выполнив, в этом году вы не можете сменить регион.",
    "areaLimitUnusedZBitWarning" : "У вас остались Z-Bit, которые будут недоступны после смены региона. Хотите продолжить?",
    "areaLimitConfirm" : "Принять",
    "areaLimitCancel" : "Отмена",
    "areaLimitInconsistencyWarning" : "Ваш регион не соответствует региону покупки.",
    "areaLimitPromptToSwitch" : "Хотите сменить регион?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Получить награду",
    "selectProductTitle" : "Выбор предмета",
    "hotSuggest" : "Хит",
    "inputKeywordSearch" : "Поиск...",
    "lookProductContent" : "Детали",
    "popupClose" : "Закрыть",
    "productSwitch" : "Сменить",
    "confirmBuy" : "Купить",
    "thinkLater" : "Позже",
    "areaLimitConfirmRegion" : "Подтвердить регион",
    "areaLimitContinuePay" : "Продолжить оплату",
    "areaLimitSwitchLimitationTwice" : "Можно менять регион аккаунта два раза в год.\n",
    "dtmslgVipRule1" : "1. Доступные игры:  \${gameName}",
    "dtmslgVipRule2" : "Каждый тип наград можно получить только один раз.",
    "dtmslgVipRule3" : "2. Событие «Очки VIP»: Купите внутриигровой предмет на нашей официальной странице, чтобы заработать очки и получить купоны за уровень и еженедельные купоны.",
    "dtmslgVipRule4" : "3. Количество очков, которые вы можете заработать, зависит от используемой вами валюты. За более подробной информацией перейдите по ссылке ниже.",
    "dtmslgVipRule5" : "4. Если при оформлении покупки используется купон на скидку, очки будут начисляться на основе уплаченной суммы.",
    "dtmslgVipRule6" : "5. Срок действия заработанных вами очков истечёт через 365 дней. Это может повлиять на ваш уровень VIP.",
    "dtmslgVipRule7" : "6. Вы получите купон за первое достижение уровня VIP. Еженедельный купон доступен в 00:00 (по UTC+0) каждую субботу.",
    "dtmslgVipRule8" : "7. Чтобы получить еженедельный купон, нужно обязательно войти в игру. Не проморгайте свой купон!",
    "dtmslgVipRule9" : "8. Купон будет в той валюте, в которой вы совершили свою последнюю покупку. Если вы хотите изменить используемую валюту, свяжитесь с нашей службой поддержки.",
    "dtmslgVipRule10" : "9. Ознакомьтесь с таблицей ниже, чтобы узнать подробнее об уровнях VIP и купонах.",
    "dtmslgVipRule11" : "10. В случае возникновения каких-либо споров команда «\${gameName}» будет иметь единоличное и окончательное право толкования настоящих Правил и Условий.",
    "dtmslgType10010" : "Суточная Скидка",
    "dtmslgType10020" : "Ограниченное Предложение",
    "dtmslgType10030" : "Герой",
    "dtmslgType10040" : "Снаряжение",
    "dtmslgType10050" : "Руна",
    "dtmslgType10060" : "Тотем",
    "dtmslgType10070" : "Святокамень",
    "dtmslgType10080" : "Дракон",
    "dtmslgType10090" : "Ресурсы",
    "dtmslgType10100" : "Здания и Технологии",
    "dtmslgType10110" : "Редкое",
    "dtmslgType10120" : "Реликвия",
    "dtmslgType10130" : "Алмаз",
    "dtmslgType10140" : "Ваучер",
    "dtmslgType2" : "Набор события",
    "dtmslgType3" : "Центр Наград",
    "dtmslgType4" : "Набор уведомления",
    "dtmslgType5" : "Набор домашней страницы",
    "dtmslgType20010" : "Набор: Черная Пятница",
    "dtmslgType20021" : "5-дн. подарок",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "В связи с обновлением функции, событие «VIP пункты» скоро прекратится.<br/>\n" +
        "Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.<br/>\n" +
        "Время окончания: 2024/08/19 08:00:00 (UTC)<br/>\n" +
        "После завершения события вы сможете посетить Центр премиум участников и получить бонусы:<br/>\n" +
        "Выполняйте квесты, чтобы зарабатывать очки и обменивать их на купоны, игровые предметы и прочие награды! Наслаждайтесь эксклюзивными преимуществами и попытками розыгрыша призов.<br/>\n" +
        "Оставайтесь на связи! Впереди много наград и событий!",
    "263RightsIntro": "В связи с обновлением функции, событие «VIP пункты» скоро прекратится.<br/>\n" +
        "Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.<br/>\n" +
        "Время окончания: 2024/09/28 00:00:00 (UTC)<br/>\n" +
        "После завершения события вы сможете посетить Центр премиум участников и получить бонусы:<br/>\n" +
        "Выполняйте квесты, чтобы зарабатывать очки и обменивать их на купоны, игровые предметы и прочие награды! Наслаждайтесь эксклюзивными преимуществами и попытками розыгрыша призов.<br/>\n" +
        "Оставайтесь на связи! Впереди много наград и событий!",
    "goToRights" : "Посетите Центр Премиум участников",
    "oldVipIntro" : "Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.",
    "pwa-20001" : "Сначала нужно войти",
    "pwa-20002" : "Неверный параметр",
    "pwa-20003" : "Назначьте персонажа",
    "pwa-20004" : "Не удалось отправить награды, повторите попытку или напишите в службу поддержки.",
    "pwa-20005" : "Вы уже получили награду.",
    "pwa-20100" : "Событие ещё не началось.",
    "pwa-20101" : "Событие завершилось.",
    "pwa-20102" : "Пока нельзя получить эти награды.",
    "pwa-20103" : "Срок действия наград истёк.",
    "pwa-1001" : "Действие выполняется слишком часто",
    "pwaCommon" : "Пожалуйста, повторите попытку позже.",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Официальный центр пополнения счёта",
    "headerSafeTip": "Полностью безопасно Быстрые транзакции",
    "safeChecking": "...проверка платежного окружения",
    "safeChecked": "Защищено и безопасно",
    "riskChecked": "Есть потенциальные риски, будьте осторожны",
    "footerSafeTitle1": "Безопасно",
    "footerSafeTitle2": "Удобно",
    "footerSafeTitle3": "Экономично",
    "footerSafeTitle4": "Эффективно",
    "footerSafeContent1": "Официальный центр пополнения счёта",
    "footerSafeContent2": "Поддержка множества методов оплаты",
    "footerSafeContent3": "Различные скидки и бонусы",
    "footerSafeContent4": "Быстрые транзакции без задержек",
    "limitedTimeActivityTitle" : "Временные преимущества",
    "limitedTimeActivityTime" : "Длительность события:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Сейчас \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Обменные курсы могут различаться, обращайтесь к этой странице за точной информацией)",
    "limitedTimeActivityNotAchieve" : "Не завершено",
    "limitedTimeActivityClaim" : "Получить",
    "limitedTimeActivityClaimed" : "Получено",
    "limitedTimeActivityTimeLeft" : "Временно: \${days}д \${hours}ч \${minutes}м \${seconds}с",
    "limitedTimeActivityRecord" : "Записи о получении",
    "limitedTimeActivityAward" : "Награды",
    "limitedTimeActivityGotTime" : "Время получения",
    "limitedTimeActivityGotRole" : "Полученный персонаж",
    "limitedTimeActivityRule" : "Правила События",
    "limitedTimeActivity285Rule1" : "1. Длительность события:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Во время события выполняйте ограниченные по времени задания, чтобы получать награды. Задания разделены по категориям недельных и месячных:",
    "limitedTimeActivity285Rule3" : "(1) Недельные задания: каждый аккаунт ограничен выполнением одной недельной задачи в неделю, которая сбрасывается каждый понедельник в 0:00.",
    "limitedTimeActivity285Rule4" : "Недельное задание входа: в течение ограниченного времени войдите один раз на страницу пополнения счета на официальном веб-сайте.",
    "limitedTimeActivity285Rule5" : "Пополните счет на любую сумму: в течение ограниченного времени пополните счет на любую сумму через официальный веб-сайт.",
    "limitedTimeActivity285Rule6" : "(2) Месячные задания: каждый аккаунт ограничен одним месячным заданием в месяц, которое сбрасывается 1-го числа каждого месяца в 0:00.",
    "limitedTimeActivity285Rule7" : "Задание входа: в течение ограниченного времени войдите один раз на страницу пополнения счета на официальном веб-сайте.",
    "limitedTimeActivity285Rule8" : "Задание накопительного пополнения: в течение ограниченного времени пополните счет на требуемую сумму, чтобы один раз получить награду.",
    "limitedTimeActivity285Rule9" : "Примечание. Из-за долгой продолжительности события обменные курсы могут колебаться. См. отображаемую на странице сумму пополнения счета.",
    "limitedTimeActivity285Rule10" : "3. Выберите персонажа, прежде чем получить награду. Награды можно будет найти в игре после их получения.",
    "limitedTimeActivityClaimAward" : "Получить награду",
    "limitedTimeActivityConfirmGot" : "Подтвердить получение",
    "limitedTimeActivityGetSucc" : "Получено успешно",
    "limitedTimeActivityGetFail" : "Получить не удалось. Попробуйте позже или обратитесь в службу поддержки.",
    "limitedTimeActivityFrequent" : "Избегайте частых действий.",
    "limitedTimeActivityLoginFirst" : "Сначала выполните вход.",
    "limitedTimeActivityWrongParam" : "Ошибка параметра",
    "limitedTimeActivityOverTips" : "Срок события истек. Обновите страницу.",
    "preRightsIntro" : "В связи с обновлением функции, событие «VIP пункты» скоро прекратится.<br/>Время окончания: \${offLineDate}<br/>Пожалуйста, убедитесь, что вы использовали свои купоны события «VIP пункты» до их исчезновения.<br/>После завершения события вы сможете посетить Центр премиум участников и получить бонусы:<br/>Выполняйте квесты, чтобы зарабатывать очки и обменивать их на купоны, игровые предметы и прочие награды! Наслаждайтесь эксклюзивными преимуществами и попытками розыгрыша призов.<br/>Оставайтесь на связи! Впереди много наград и событий!",
    "riskTipTitle" : "Остерегайтесь незаконный действий и мошенничества",
    "riskTipContent" : "Дорогой игрок,\n\nМы обратили внимание, что некоторые игроки совершают действия, которые влияют на справедливость и честность в игре. Ниже приведены наиболее распространённые нарушения:\n\n1. Размещение неправомерной рекламы: публикация незаконной рекламы с использованием чата в игре или других способов, включая призывы к незаконной торговле ресурсами или незаконному пополнению счета.\n2. Использование читов или скриптов: использование читов, скриптов или других технических средств для незаконного получения ресурсов.\n3. Незаконные приглашения: рассылка приглашений в чате с целью вовлечения игроков для общения на внешних каналах (например, Line, Discord).\n4. Незаконное пополнение счёта: привлечение игроков для неофициального пополнения счёта со скидками.\n5. Другие виды мошенничества: участие в мошенничестве, когда люди выдают себя за официальных сотрудников компании.\n\nМы призываем всех игроков серьезно относиться к защите своих личных данных и имуществу. Не доверяйте мошенническим сообщениям и сомнительным сообщениям от незнакомцев. Подобные действия несут для вас большие риски, включая потенциальную кражу учетной записи или вовлечение в мошеннические схемы. Обратите внимание, что мы не будем заниматься компенсацией убытков, возникших в результате подобных действий.\n\nК аккаунтам, которые будут вовлечены в описанные выше мошеннические действия, будут применены соответствующие меры, степень которых будет зависеть от серьезности и последствий нарушений. Меры могут включать предупреждения, конфискацию незаконно полученных доходов и ресурсов, временная или даже пожизненная блокировка аккаунта. Если вы столкнетесь с подозрительными действиями в игре, сообщите об этом в нашу службу поддержки. Мы тут же займемся проверкой и примем необходимые меры. Благодарим вас за понимание и поддержку.",
    "linkValid": "Ссылка больше не действует",
    "-" : "-",
    "accountLabel": "Аккаунт",
    "passwordLabel": "Пароль",
    "confirmPasswordLabel": "Подтвердите Пароль",
    "confirmDeleteTitle" : "Вы уверены, что хотите удалить свой аккаунт и всех персонажей?",
    "confirmDeleteYes" : "Да. Я хочу удалить свой аккаунт и всех персонажей.",
    "selectGame" : "Выбрать игру",
    "confirmDeleteNo" : "Нет. Я хочу удалить персонажа, но не хочу удалять весь аккаунт.",
    "delTermsTitle" : "Пожалуйста, внимательно ознакомьтесь с требованиями к удалению аккаунта и извещение об удалении аккаунта.",
    "delCondTitle" : "1. Требования к удалению аккаунта",
    "delCond1" : "(1) Сначала вам нужно войти в свой игровой аккаунт, если не можете войти [восстановите аккаунт]. При этом убедитесь, что аккаунт и персонаж принадлежат вам.",
    "delCond2" : "(2) Убедитесь, что на вашем аккаунте и у персонажа <span>нет рисков для безопасности</span>, включая нерешенные жалобы, отчёты, расследования, судебные решения и иски (ваши или против вас).",
    "delCond3" : "(3) Убедитесь, что на вашем аккаунте и у персонажа <span>нет текущих платежей</span>, включая возвраты платежей или активные подписки.",
    "delNoticeTitle" : "2. Извещение об удалении аккаунта",
    "delNotice1" : "(1) Удаление аккаунта и персонажей на нём – <span>это необратимый процесс</span>.",
    "delNotice2" : "(2) <span>Завершите все текущие процедуры, связанные с игровым имуществом</span>, включая, но не ограничиваясь, предметами, игровой валютой и подписками, поскольку они будут безвозвратно утрачены при удалении аккаунта. После закрытия игрового сервера возврат средств на удаленных аккаунтах или персонажах не производится.",
    "delNotice3" : "(3) Удаление данных аккаунта и персонажа также приведет к удалению всей связанной с ними информации. Однако вам придется самостоятельно отключить привязку и управлять данными, связанными с аккаунтами в социальных сетях (например, Facebook).",
    "delNotice4" : "(4) Для защиты ваших интересов будет запущен период ожидания (период заморозки) на 14 дней (за исключением случаев, когда это регулируют местные законы), в течение которого вы можете обратиться в службу поддержки, чтобы отменить запрос на удаление.",
    "delNotice5" : "(5) После подачи заявки ваш аккаунт будет сразу заблокирован, однако на удаление данных может потребоваться до недели. По завершении процедуры вам на электронную почту придёт уведомление.",
    "delFormConfirm1" : "Я понимаю условия и последствия удаления аккаунта.",
    "delFormConfirm2" : "На этом аккаунте нет открытых жалоб или судебных разбирательств.",
    "delForm" : "Я прочитал и согласен с <a class=\"account-delete-link\" href=\"javascript:;\">Соглашением по удалению аккаунта</a>.",
    "cannotDeleteMsgTitle" : "Невозможно удалить аккаунт",
    "cannotDeleteMsg1" : "Ваш аккаунт не соответствует требованиям для удаления:",
    "cannotDeleteMsg2" : "У вас есть нерешенные запросы в службу поддержки. Завершите их и повторите запрос.",
    "cannotDeleteMsg3" : "У вас есть нерешенный возврат средств. Завершите его и повторите запрос на удаление аккаунта.",
    "cannotDeleteMsg4" : "В данный момент ваш аккаунт находится на проверке из-за сообщений или жалоб от игроков. Дождитесь завершения проверки и повторите запрос.",
    "formCompleted" : "Обращение отправлено",
    "formCheckMsg1" : "Ваше обращение отправлено, ожидайте рассмотрения и ответа.",
    "formCheckMsg2" : "Прогресс рассмотрения можно проверить в <span class=\"account-delete-link\">[Мои запросы]</span>.",
    "delEmailMsg1" : "Уведомить вас по электронной почте после удаления?",
    "delEmailMsg2" : "Удаление аккаунта займет около недели ввиду обработки данных. Хотите получить уведомление на электронную почту после завершения процедуры?",
    "delEmailMsg3" : "Ваш адрес электронной почты будет использоваться только для уведомления.",
    "delEmailConfirmYes" : "Да, уведомите меня по электронной почте.",
    "delEmailFill" : "Укажите адрес электронной почты для уведомления.",
    "delEmailConfirmNo" : "Нет, не уведомляйте меня по электронной почте.",
    "delCoolMsg1" : "Хотели бы вы воспользоваться периодом заморозки в 14 дней?",
    "delCoolMsg2" : "В течение 14-дневного периода заморозки ваш аккаунт будет заблокирована, и вы можете в любое время отправить запрос на отмену удаления. По истечении этих 14 дней, если вы не отмените запрос на удаление, ваш аккаунт будет окончательно удален без возможности восстановления.",
    "delCoolMsg3" : "Если вы не хотите воспользоваться периодом заморозки, ваш аккаунт будет удалён сразу после одобрения вашей заявки. Восстановить аккаунт будет невозможно.",
    "delCoolConfirmYes" : "Да, я хочу использовать 14-дн. период заморозки.",
    "delCoolConfirmNo" : "Нет, можно сразу удалить аккаунт.",
    "delSecondCheckMsg1" : "Вы уверены, что разобрались со всем контентом на своём аккаунте и хотите активировать период заморозки аккаунта? После активации ваш аккаунт будет недоступен.",
    "delSecondCheckConfirmYes" : "Да, активировать сейчас.",
    "delResMsg1" : "Запрос на удаление вашего аккаунт отправлен. Указанный аккаунт отправлен на период заморозки:",
    "gameName" : "Игровое имя:",
    "gameAccount" : "Игровой аккаунт:",
    "delResMsg2" : "<span>Сделайте снимок экрана и сохраните указанную информацию о вашем аккаунте, поскольку это будет единственным доказательством, если вы захотите восстановить свой аккаунт в течение периода заморозки</span>.",
    "delResMsg3" : "Период заморозки: 14 дней. Осталось:",
    "delResMsg4" : "Чтобы отменить запрос на удаление аккаунта во время периода заморозки, нажмите [Служба поддержки].",
    "copyAccountInfo" : "Скопировать данные аккаунта",
    "delResMsg5" : "Запрос на удаление вашего аккаунта обработан. Запущен процесс удаления, поэтому вы не можете войти в свой аккаунт.",
    "delResMsg6" : "Процесс удаления займет некоторое время, поскольку нам придется обработать и удалить большой объем данных. Мы планируем завершить процесс удаления примерно через неделю.",
    "delResMsg7" : "Если вы указали адрес электронной почты для уведомления, мы отправим на него сообщение.",
    "delResMsg8" : "Если вы снова захотите войти в игру, пожалуйста, зарегистрируйте новый аккаунт.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Другие каналы",
    "itemWrong" : "Этот пункт заполнен неправильно, пожалуйста, введите его повторно.",
    "delRegisterTime" : "Дата регистрации",
    "delDevice" : "Обычно используемое устройство",
    "delIp" : "Häufig verwendete IP-Adresse",
    "delHistoryPayChannel" : "Исторические каналы пополнения",
    "delHistoryPayOrder" : "Bisherige Bestellnummern",
    "delDeleteReason" : "Причина удаления аккаунта",
    "delPrevStep" : "Назад",
    "delNextStep" : "Далее",
    "delSecondCheckMsg2" : "Вы уверены, что разобрались со всем содержимым аккаунта и готовы к его удалению? После удаления аккаунт будет навсегда утерян.",
    "pleaseFillIn" : "Пожалуйста, предоставьте следующую информацию",
    "switchNewVersion": "Сменить на новую",
    "switchNewVersionPlatform": "Платёжную платформу",
    "updateVersionPopupContent": "Чтобы обеспечить плавную работу игры и поддержку новых функций, мы рекомендуем обновить систему устройства для более стабильной работы и оптимизации совместимости.",
    selectTopupTips:"90% игроков выбирают официальный магазин.",
    chuzhi: "Пополнение",
    selectMethods: "Способ оплаты",
    landscapeTip2: "Пожалуйста, поверните телефон в портретный режим для лучшего опыта",
    v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
    ckoNotAvailable: 'Ошибка платежного сервиса, повторите попытку позже.',
    ckoSubmitFail: 'Платеж не прошел. Проверьте данные или используйте другую карту. Если средства были списаны, они будут возвращены на исходный способ оплаты.',
    gotoFinish: 'Выполнить'
}